let memoryStorage: Record<string, any> = {}

function getItem(keyName: string) {
  return memoryStorage[keyName]
}

function setItem(keyName: string, keyValue: any) {
  memoryStorage[keyName] = keyValue
}

function removeItem(keyName: string) {
  delete memoryStorage[keyName]
}

function clear() {
  memoryStorage = {}
}

export default {
  getItem,
  setItem,
  removeItem,
  clear,
}
